export default "__VITE_ASSET__0847d431__"